import React, {
    useContext, useEffect, useMemo, useState,
} from 'react';
// @ts-ignore
import Burger from 'assets/svg/burger_v2.svg';
import cn from 'classnames';

import { selectedPeriodVar } from 'app/apollo/reaction';
import { menuDatesState } from 'app/containers/contexts/menuDates.context';
import { IFiltersContext } from 'app/containers/contexts/filters.context/filtersContext.type';
import { FiltersContext } from 'app/containers/contexts/filters.context/filters.context';
import { getDateData } from 'app/utils/date';
import { ONE_DAYS_IN_UTC_FORMAT } from 'app/containers/contexts/menuDates.consts';
import { LocaleContext } from 'app/containers/LocaleProvider';
import { useMenuPeriodsData, useSpecificPeriodData } from 'app/hooks/accessors';
import { PathSegmentContext } from 'app/views/Main/PathSegment.context';
import { extraPeriodNyDates, extraPeriodNYStart } from 'global/const/ny';
import { LocationContext } from 'app/containers/LocationProvider';
import {
    MENU_SORT_DATES, MENU_SORT_DATES_CONTROL, MENU_SORT_DATES_TEST,
} from 'app/containers/contexts/abTest.context';
import { useParticipantIdABTest } from 'app/views/Menu/Menu/hooks/useParticipantIdABTest';
import FilterIcon from './img/filter_v2.component.svg';
import RightArrow from './img/right_v2.component.svg';
import css from './BR1258MobileHeader.module.scss';

const formatPeriodToTagTitle = (
    start: string,
    end: string,
    locale: string,
) => {
    const firstDateMeta = getDateData(start, locale);
    const secondDateMeta = getDateData(end, locale);

    const fisrtDateString = `${firstDateMeta?.rawData?.date} ${firstDateMeta?.monthShortNameForDate}`;
    const secondDateString = `${secondDateMeta?.rawData?.date} ${secondDateMeta?.monthShortNameForDate}`;

    return `${fisrtDateString} — ${secondDateString}`;
};

const generateDateDataFromDiff = (date: string, weekDayName: string) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    const currentDate = d.getTime() / 1000;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayD = today.getTime() / 1000;


    const isTomorrow = `${(currentDate - todayD)}` === ONE_DAYS_IN_UTC_FORMAT;

    return isTomorrow ? 'завтра' : weekDayName;
};


const MobileHeaderCityAndDateSelect = (props: any) => {
    const {
        handleOpenPopup, deliveryDate, title, isBurgerOpen,
    } = props;
    const { location: { pathname } } = window;

    const { segment } = useContext(PathSegmentContext);

    const isProfilePage = useMemo(
        () => pathname.includes('profile'),
        [pathname],
    );

    const isDeliveryMenu = useMemo(
        () => segment === 'delivery',
        [segment],
    );


    if (isProfilePage || isBurgerOpen || isDeliveryMenu) {
        return null;
    }

    return (
        <button
            onClick={handleOpenPopup}
            type="button"
            className={css.cityAndDateButtonRoot}
        >
            <div className={css.cityAndDateContent}>
                <div className={css.cityAndTitle}>
                    <div className={`body-xxs-medium ${css.cityAndTitleText}`}>
                        дата и город доставки
                    </div>
                    <div className={css.cityAndTitleIcon}>
                        <RightArrow />
                    </div>
                </div>
                <div className={`body-s-medium ${css.cityAndTitleLocation}`}>
                    <span className={css.cityAndTitleLocatoinWhen}>
                        {deliveryDate}
                        ,&nbsp;
                    </span>
                    <span className={css.cityAndTitleLocatonTo}>
                        {title}
                    </span>
                </div>
            </div>
        </button>
    );
};

const FilterButton = (props: any) => {
    const {
        onClickFilters, isBurgerOpen,
    } = props;
    const { location: { pathname } } = window;

    const isProfilePage = useMemo(
        () => pathname.includes('profile'),
        [pathname],
    );

    if (isProfilePage || isBurgerOpen) {
        return null;
    }

    return (
        <button
            onClick={() => {
                onClickFilters();
            }}
            type="button"
            className={css.filtersButtonRoot}
        >
            <div className={css.filtersButtonIcon}>
                <FilterIcon />
            </div>
        </button>
    );
};

export function BR1258MobileHeader(props: any) {
    const {
        onClickMobileNavigationButton,
        handleOpenPopup,
        title,
        onClickFilters,
        isProfile,
        isDeliveryMenu,
    } = props;

    const {
        locationKey,
    } = useContext(LocationContext);

    const [isBurgerOpen, setIsBurgerOpen] = useState(false);

    const burgerButtonclasses = cn({
        [css.burgerButton]: true,
        [css.isOpen]: isBurgerOpen,
        [css.isClose]: !isBurgerOpen,
    });


    // Берем значение из проклятой задачи
    const {
        state: {
            selectedDate,
            filterPeriod,
        },
    } = useContext(menuDatesState);

    const { locale } = useContext(LocaleContext);

    const period = useSpecificPeriodData();

    const {
        start: selectedPeriodStart,
        end: selectedPeriodEndRaw,
        // tags,
    } = period;

    /* SELECTORS | ИНТЕРПРАЙЗ ВЫЧЕСЛЕНИЯ */
    // Функция отдает разные данные по дате
    // TODO: когда нибудь ее надо переписать на TS, этой функции это очень нужно
    // TODO: этого не достаточно чтобы отобразить дату, нужно проверить еще и период
    const dateMeta = useMemo(
        () => getDateData(selectedDate, locale),
        [selectedDate, locale],
    );

    const { weekDayName } = dateMeta;

    const deliveryDate = useMemo(() => {
        // Тут мы проверяем в одинаковых ли переодах код из проклятой задачи и период из url`а
        // Нужно для того чтобы отобразить либо интервал дат либо день

        const isQuaziPeriod = extraPeriodNyDates[extraPeriodNYStart][0] === period.start
            && extraPeriodNyDates[extraPeriodNYStart][1] === period.end;

        const isFilterPeriodSelected = filterPeriod === period.start;
        return isFilterPeriodSelected
            ? generateDateDataFromDiff(dateMeta.rawData.dateValue, weekDayName)
            // @ts-ignore
            : formatPeriodToTagTitle(selectedPeriodStart, selectedPeriodEndRaw, locale, isQuaziPeriod, locationKey);
    }, [
        weekDayName,
        filterPeriod,
        selectedPeriodEndRaw,
        locale,
        dateMeta.rawData.dateValue,
        period.start,
        selectedPeriodStart,
        locationKey,
    ]);

    return (
        <div className={css.BR1258MobileHeaderRoot}>
            <div className={css.burgerButtonContainer}>
                <button
                    onClick={() => {
                        setIsBurgerOpen(!isBurgerOpen);
                        onClickMobileNavigationButton();
                    }}
                    type="button"
                    className={burgerButtonclasses}
                >
                    <Burger data-referral-menu-item="true" />
                </button>
            </div>
            <MobileHeaderCityAndDateSelect
                title={title}
                deliveryDate={deliveryDate}
                handleOpenPopup={handleOpenPopup}
                isBurgerOpen={isBurgerOpen}
            />
            <FilterButton
                isBurgerOpen={isBurgerOpen}
                onClickFilters={onClickFilters}
            />
        </div>
    );
}
